import PageHero from "@/components/sections/PageHero";
import Surfaces from "@/components/sections/Surfaces";

export default function SurfacesPage() {
  return (
    <>
      <PageHero
        eyebrow="/ Surfaces extérieures"
        title="Box, balcon, parking"
        accent="terrasses & locaux"
        description="Nettoyage haute pression de vos surfaces extérieures à domicile ou en entreprise. Petites surfaces au m², grandes surfaces et locaux commerciaux sur devis."
      />
      <Surfaces />
    </>
  );
}
